<template>
  <nav class="d-flex justify-center">
    <v-container :class="$vuetify.breakpoint.lgAndUp ? 'pa-0 px-12' : 'pa-0'" fluid>
      <v-toolbar class="px-0 elevation-0 background toolbar-spacing w-100">
        <v-menu open-on-hover offset-y max-width="300" max-height="2000px" class="py-2" auto>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" link text class="text-transform-none no-letter-spacing">{{ $t('button.getTheApp') }}</v-btn>
          </template>

          <v-list dense flat>
            <v-list-item inactive>
              <v-list-item-title class="font-weight-bold primary--text text--darken-1 text-body-2">{{ $t('label.pleaseDownloadTheAppFrom') }}</v-list-item-title>
            </v-list-item>
            <v-list-item inactive class="d-flex">
              <a href="https://play.google.com/store/apps/details?id=com.oliving.app" target="_blank" class="ma-auto">
                <img class="app-store-badge" src="@/assets/google-play-badge.png" />
              </a>
            </v-list-item>
            <v-list-item inactive class="d-flex">
              <a href="https://apps.apple.com/my/app/oly/id1572981807" target="_blank" class="ma-auto">
                <img class="app-store-badge mb-2" src="@/assets/app-store-badge.png" />
              </a>
            </v-list-item>
            <v-list-item inactive class="d-flex">
              <a href="https://urldra.cloud.huawei.com/dbR4hINcpG" target="_blank" class="ma-auto">
                <img class="app-store-badge" src="@/assets/huawei.png" />
              </a>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn v-if="isSGUser || !currentUser" link text class="disable-button-overlay text-capitalize no-letter-spacing" :to="{ name: $constants.ROUTE_NAME.SALON_INFO_LIST }">
          {{ $t('label.ourStores') }}
        </v-btn>
        <!-- <v-text-field dense v-model="productSearch" :placeholder="$t('label.productSearchPlaceholder')" append-icon="mdi-magnify" outlined rounded hide-details class="flex-grow-1" /> -->
        <v-spacer></v-spacer>
        <v-btn v-if="currentUser" text class="d-flex align-center ml-1" :to="{ name: $constants.ROUTE_NAME.WALLET }">
          <span class="d-flex align-center mx-2 text-capitalize">
            <img height="30px" class="mr-2" src="@/assets/coin.png" />
            {{ currentUser.point }} {{ $t('label.points') }}
          </span>
          <span class="d-flex align-center mx-2 text-capitalize" v-if="isSGUser">
            <img height="24px" class="mr-2" src="@/assets/voucher.png" />
            {{ currentUser.voucher_count }} {{ $t('label.vouchers') }}
          </span>
        </v-btn>
        <div>
          <v-btn v-if="currentUser" link text class="text-transform-none no-letter-spacing" :to="{ name: $constants.ROUTE_NAME.ORDER_DASHBOARD }" exact>{{ $t('label.myOrder') }}</v-btn>
          <v-btn fab depressed color="white" small class="ml-3" @click="navigateTo($constants.ROUTE_NAME.PRODUCT_WISH_LIST)">
            <v-icon color="primary" class="transparent">$heart</v-icon>
          </v-btn>
          <v-btn fab depressed color="white" small class="ml-3" @click="navigateTo($constants.ROUTE_NAME.ORDER_CART)">
            <v-icon color="primary" class="transparent">$cart</v-icon>
          </v-btn>
          <v-menu open-on-hover offset-y v-if="currentUser">
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab depressed color="white" small class="ml-3" v-if="currentUser" v-bind="attrs" v-on="on">
                <v-icon color="primary" class="transparent">$profile</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item link :to="{ name: $constants.ROUTE_NAME.PROFILE }" dense>
                <v-list-item-title class="text-uppercase text-body-2 font-weight-medium">{{ $t('label.myProfile') }}</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{ name: $constants.ROUTE_NAME.PRODUCT_REVIEW }" dense>
                <v-list-item-title class="text-uppercase text-body-2 font-weight-medium">{{ $t('label.productReview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isSGUser" link :to="{ name: $constants.ROUTE_NAME.SALON_STYLIST_REVIEW_LIST }" dense>
                <v-list-item-title class="text-uppercase text-body-2 font-weight-medium">{{ $t('label.salonStylistReview') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar>
    </v-container>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'SearchBar',
  data() {
    return {
      productSearch: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['isSGUser']),
    ...mapState('auth', ['currentUser'])
  },
  methods: {
    navigateTo(path) {
      if (this.currentUser) this.$router.push({ name: path })
      else this.$root.$app.openLoginDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .center-toolbar-content > .v-toolbar__content {
  justify-content: space-between;
  position: relative;
}

.position-absolute {
  position: absolute;
}

.searchbar-right {
  right: 0.8rem;
}

.app-store-badge {
  max-width: 120px;
}
</style>
